import { useIsImproveMpPerformanceTier2Enabled } from '@hooks/use-improve-mp-performance-tier-2';
import { useTrackOpenFilterMenu } from '@hooks/use-track-open-filter-menu';
import { useAppSelector } from '@redux/hooks';
import { Icon } from '@tkww/orion-web-ds-graphic';
import React, { type FunctionComponent, useMemo } from 'react';
import { connect } from 'react-redux';
import { afterNextPaint } from '../../../../../../../helpers/after-next-paint';
import Pill from '../../../../../../components/shared/PillWithDropdown/Pill';

import { isSidebarOpenAtom } from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { useAtom } from 'jotai';
import { useAppliedFilterCount } from '../../hooks/use-applied-filter-count';
import { useInitializeSelectedSidebarFilters } from '../../hooks/use-initialize-selected-sidebar-filters';
import Styles from './styles.scss';

interface StateProps {
	mobileUI: boolean;
}

interface MapViewButtonProps {
	showMapView: boolean;
}

type Props = StateProps & MapViewButtonProps;

const OnePillLabel = ({ children }: { children: React.ReactNode }) => (
	<div className={Styles.innerAlign}>
		<Icon name="filter" size="sm" aria-label="Filters" />
		<span>{children}</span>
	</div>
);

const PillMore: FunctionComponent<Props> = ({ mobileUI, showMapView }) => {
	const trackOpenFilterMenu = useTrackOpenFilterMenu();
	const isImproveMpPerformanceTier2Enabled =
		useIsImproveMpPerformanceTier2Enabled();
	const [isSidebarOpen, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
	const appliedFiltersCount = useAppliedFilterCount();
	const initializedSelectedSidebarFilters =
		useInitializeSelectedSidebarFilters();
	const vendorCategoryCode = useAppSelector((state) => state.category.code);
	const displayMarketCode = useAppSelector(
		(state) => state.location.marketCode,
	);

	const labelPrefix = useMemo(() => {
		return mobileUI ? 'Filters' : '+ More Filters';
	}, [mobileUI]);

	const labelText = useMemo(() => {
		const count = appliedFiltersCount > 0 ? ` (${appliedFiltersCount})` : '';
		return `${labelPrefix}${count}`;
	}, [labelPrefix, appliedFiltersCount]);

	const label = useMemo(() => {
		return mobileUI ? <OnePillLabel>{labelText}</OnePillLabel> : labelText;
	}, [mobileUI, labelText]);

	const handleClick = () => {
		afterNextPaint(() => {
			if (!isSidebarOpen) {
				trackOpenFilterMenu('more_filters', {
					vendorCategoryCode,
					displayMarketCode,
				});
			}
			initializedSelectedSidebarFilters();
			setIsSidebarOpen(!isSidebarOpen);
		});
	};

	return (
		<Pill
			label={label}
			onClick={handleClick}
			selected={isSidebarOpen}
			showMapView={showMapView}
			isImproveMpPerformanceTier2Enabled={isImproveMpPerformanceTier2Enabled}
		/>
	);
};

const mapStateToProps = (state: Redux.State): StateProps => ({
	mobileUI: state.viewport.isMobile,
});

export default connect(mapStateToProps)(PillMore);
